type BuildingIconProps = {
  color?: string;
  size?: number | string;
};

export const BuildingIcon = ({ color = 'currentColor', size = 16 }: BuildingIconProps): JSX.Element => (
  <svg style={{ color }} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 4.66667H6.83333M5 7.33333H6.83333M5 10H6.83333M9.16666 4.66667H11M9.16666 7.33333H11M9.16666 10H11M13.3333 14V4.13333C13.3333 3.3866 13.3333 3.01323 13.188 2.72801C13.0602 2.47713 12.8562 2.27316 12.6053 2.14532C12.3201 2 11.9467 2 11.2 2H4.8C4.05326 2 3.67989 2 3.39468 2.14532C3.1438 2.27316 2.93982 2.47713 2.81199 2.72801C2.66667 3.01323 2.66667 3.3866 2.66667 4.13333V14M14.6667 14H1.33333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
